<div class="modal-content">

    <div class="modal-body">
        <div class="card p-4 login">
            <div class="card-body" id="login">
                <button id="cancel-btn" class="btn cancel-btn px-4" (click)="onCancel()">X</button>
                <h1 class="" style="font-size: 16px;">
                    Be the first to watch. Register  to join our Beta  launch.</h1>
                <br>
                <form [formGroup]="loginFormGroup" autocomplete="off" *ngIf="!iserrorMessage">
                    <!-- <div *ngIf="!forgetPasswordMode"> -->
                    <div class="form-group">

                        <label class="form-label mb-1 loginLabel" for="inputUserName">Email Address <span
                                class="required-field">*</span></label>

                        <input nbInput fullWidth fieldSize="giant" formAutoFocus type="text" class="form-control"
                            id="inputUserName" placeholder="Email Address" formControlName="email"
                            [ngClass]="{ 'is-invalid': isCheckValidation && loginControls.email.errors }">
                        <small class="form-error-text" *ngIf="(isCheckValidation && !!loginControls?.email.errors) ||
                            (!!loginControls?.email.touched && !!loginControls?.email.invalid)">
                            <ng-container class="pt-2" *ngIf="!!loginControls?.email.errors.required">
                                {{ loginMessage.email.errors.required }}
                            </ng-container>
                        </small>
                        <small class="form-error-text" *ngIf="(isCheckValidation && !!loginControls?.email.errors) ||
                            (!!loginControls?.email.touched && !!loginControls?.email.invalid)">
                            <ng-container class="pt-2" *ngIf="loginControls?.email.errors.checkEmail">
                                {{ loginMessage.email.errors.invalid }}
                            </ng-container>
                        </small>

                    </div>
                    <div class="form-group">

                        <label class="form-label mb-1 loginLabel" for="inputPassword">Name <span
                                class="required-field">*</span></label>
                        <input nbInput fullWidth fieldSize="giant" type="text" class="form-control"
                            id="inputPassword" placeholder="Name" 
                            formControlName="password"
                           >
                       
                    </div>
                

                    

                    <div id="login-box" style="padding-top: 10px;">
                        <!-- <nb-checkbox name="rememberMe" class="float-left">Remember me</nb-checkbox> -->
                        <!-- <nb-checkbox name="rememberMe" class="float-right">Remember me</nb-checkbox> -->
                        <div class="d-flex justify-content-center">
                            <button id="login-btn" class="btn px-4" *ngIf="isSignUp"
                                (click)="onSubmitClick()">Submit</button>

                           

                            <button id="cancel-btn" class="btn px-4" (click)="onCancel()">Cancel</button>
                        </div>
                    </div>

                
                    <br>
                    
                </form>

                <div class="text-center"  *ngIf="iserrorMessage">
                    <p id="error-message">
                        {{ errorMessage }}
                    </p>
                </div>

            </div>
        </div>
    </div>